import { serviceGo } from '@/utils/request'
import { PlatformNewData } from './platformNewData'

// 初始小说分组新增数据：同一份平台新增数据结构，按「初始小说/非初始/全部」三个 scope 各返回一份
export interface InitialBookNewDataParams {
  initial_game_id: number
  n_days: 0 | 1 | 3 | 7 | 14 | 30  // 注册起第 N 个自然日内的行为（0=注册当天）
  start_date: string               // 注册日期范围起（yyyy-MM-dd，北京时间，闭区间）
  end_date: string                 // 注册日期范围止
  channel: 'toutiao' | 'kuaishou' | 'other' | 'all'
  version: string                  // 版本筛选（如 '1.0.16'，后端缺省 1.0.16，同平台看板）
  version_mode: 'gte' | 'eq'       // gte=该版本及之后 | eq=仅该版本
}

export interface InitialBookNewDataResp {
  init: PlatformNewData      // 初始小说 = 该书的新增用户
  non_init: PlatformNewData  // 非初始小说 = 初始小说不是该书的新增用户
  all: PlatformNewData       // 全部 = 不按初始小说筛选
}

// 拉取初始小说分组新增数据（Go 后端，需管理员权限）
export async function getInitialBookNewData(params: InitialBookNewDataParams): Promise<InitialBookNewDataResp> {
  const res = await serviceGo.get('/api_v2/admin/initial-book-new-data', { params })
  return res.data.data
}

// 初始小说下拉选项：注册窗口内实际有人以它为初始小说的书及人数（降序）
export interface InitialBookOption {
  game_id: number
  title: string
  user_count: number  // = 选中该书后「初始用户」列头人数（口径与主接口一致）
}

export type InitialBooksParams = Omit<InitialBookNewDataParams, 'initial_game_id' | 'n_days'>

export async function getInitialBooks(params: InitialBooksParams): Promise<InitialBookOption[]> {
  const res = await serviceGo.get('/api_v2/admin/initial-books', { params })
  return res.data.data || []
}
